import * as angular from 'angular';
import { config } from 'angular/utils/config';

class NetworkPointHeaderComponentCtrl implements ng.IController {
    networkPoint: NetworkPointDto;
    public stageConfig = config;

    constructor() {}

    $onInit() {}
}

angular.module('app').component('pkpNetworkPointHeader', {
    controller: NetworkPointHeaderComponentCtrl,
    template: require('app/network-point/network-point-header.component.html'),
    bindings: {
        networkPoint: '='
    }
});
